import React from 'react';
import WithAddableInputFormTemplate from 'routes/Profile/components/ProfileContent/WithAddableInputFormTemplate';
import { INewInitalFieldsProps } from 'routes/Profile/components/ProfileContent/WithAddableInputFormTemplate/types';
import * as Yup from 'yup';

import { ITransactionTypeTabsProps } from '../types';

const validations = {
  clientRONFee: Yup.number().typeError('Must be number').moreThan(0, 'Must be bigger than 0').required('Required'),
  clientInPersonFee: Yup.number().typeError('Must be number').moreThan(0, 'Must be bigger than 0').required('Required'),
  notaryGetRON: Yup.number().typeError('Must be number').moreThan(0, 'Must be bigger than 0').required('Required'),
  notaryGetInPerson: Yup.number().typeError('Must be number').moreThan(0, 'Must be bigger than 0').required('Required'),
  durationRON: Yup.number().typeError('Must be number').moreThan(0, 'Must be bigger than 0').required('Required'),
  durationInPerson: Yup.number().typeError('Must be number').moreThan(0, 'Must be bigger than 0').required('Required'),
  name: Yup.string().required('Required'),
  description: Yup.string().required('Required'),
};

const TransactionTypeForm: React.FC<ITransactionTypeTabsProps> = ({ activeTransactionType, formRef, onSubmit }) => {
  const formInputFields: INewInitalFieldsProps[] = [
    {
      inputProps: [
        {
          name: 'name',
          placeholder: 'Type Name',
          label: 'Type',
          defaultValue: activeTransactionType?.name,
        },
        {
          name: 'description',
          placeholder: 'Description',
          label: 'Description',
          defaultValue: activeTransactionType?.description,
        },
      ],
    },
    {
      inputProps: [
        {
          name: 'notaryGetRON',
          label: 'Notary Price - RON',
          defaultValue: activeTransactionType?.defaultPrice?.notaryGetRON || '0',
          inputSettings: { prefix: '$' },
          sideFields: [
            {
              name: 'notaryGetInPerson',
              label: 'Notary Price - In Person',
              size: 12,
              defaultValue: activeTransactionType?.defaultPrice?.notaryGetInPerson || '0',
              inputSettings: { prefix: '$' },
            },
          ],
        },
      ],
    },
    {
      inputProps: [
        {
          name: 'clientRONFee',
          label: 'Client Price - RON',
          defaultValue: activeTransactionType?.defaultPrice?.clientRONFee || '0',
          inputSettings: { prefix: '$' },
          sideFields: [
            {
              name: 'clientInPersonFee',
              label: 'Client Price - In Person',
              size: 12,
              defaultValue: activeTransactionType?.defaultPrice?.clientInPersonFee || '0',
              inputSettings: { prefix: '$' },
            },
          ],
        },
      ],
    },
    {
      inputProps: [
        {
          name: 'durationRON',
          label: 'Duration - RON (hour)',
          defaultValue: (activeTransactionType?.configs?.RON?.duration || 0) / 3600,
          sideFields: [
            {
              name: 'durationInPerson',
              label: 'Duration - In Person (hour)',
              size: 12,
              defaultValue: (activeTransactionType?.configs?.IN_PERSON?.duration || 0) / 3600,
            },
          ],
        },
      ],
    },
  ];

  // const [createTransactionType] = useMutation(CREATE_TRANSACTION_TYPE);
  // const [updateTransactionType] = useMutation(UPDATE_TRANSACTION_TYPE);
  // const [deleteTransactionType] = useMutation(DELETE_TRANSACTION_TYPE);

  // const callCreateTransactionType = async (v: any) => {
  //   const newTransactionTypeValues = {
  //     service: activeService?.id,
  //     name: v?.name,
  //     description: v?.description,
  //     priceInput: {
  //       clientRONFee: parseFloat(v?.clientRONFee || ''),
  //       clientInPersonFee: parseFloat(v?.clientInPersonFee || ''),
  //       notaryGetInPerson: parseFloat(v?.notaryGetInPerson || ''),
  //       notaryGetRON: parseFloat(v?.notaryGetRON || ''),
  //     },
  //   };
  //   try {
  //     // edit
  //     if (activeTransactionType && !callbackOnDeleteSuccess) {
  //       await updateTransactionType({
  //         variables: {
  //           updatedDoc: newTransactionTypeValues,
  //           filter: {
  //             id: activeTransactionType.id,
  //           },
  //         },
  //       });
  //       callbackOnEditSuccess?.();
  //     }
  //     // delete
  //     else if (activeTransactionType && callbackOnDeleteSuccess) {
  //       await deleteTransactionType({
  //         variables: {
  //           id: activeTransactionType.id,
  //         },
  //       });
  //       callbackOnEditSuccess?.();
  //     }
  //     // create
  //     else {
  //       await createTransactionType({
  //         variables: {
  //           doc: { ...newTransactionTypeValues, id: activeTransactionType?.id },
  //         },
  //       });
  //       callbackOnCreateSuccess?.();
  //     }
  //     refetch?.();
  //   } catch (err) {
  //     console.log('ERROR', err);
  //   }
  // };

  const onSubmitForm = (v: any) => {
    onSubmit?.(v);
  };

  return (
    <div style={{ overflow: 'auto', height: '100%' }}>
      <WithAddableInputFormTemplate
        initialFields={formInputFields}
        validation={validations}
        formRef={formRef}
        // portalButtonClassName='.transaction-type-form-submit-button'
        onSubmit={onSubmitForm}
        hideSaveButton
        // submitButtonLabel='Save'
      />
    </div>
  );
};
export default React.memo(TransactionTypeForm);
